const buttons = {
  baseStyle: {},
  variants: {}
}

export default buttons;